/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StudentDashboardStyles
 *
 * @file StudentDashboardStyles.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */

import { makeStyles } from '@material-ui/core';
import mixins from '../../../../assets/styles/mixins.scss';

const StudentListStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    margin: 0,
    padding: 0
  },
  action: {
    padding: '12px 16px 12px 8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 1
  },
  listItem: {
    borderRadius: 8,
    border: '1px solid transparent',
    marginBottom: 4,
    padding: 0,
    backgroundColor: theme.palette.background.paper
  },
  listItemActive: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2
  },
  mainText: {
    color: mixins.color_text_primary,
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight600,
    lineHeight: mixins.lineHeight150
  },
  labelText: {
    color: mixins.greyScaleColor,
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight500,
    lineHeight: '166.667%'
  },
  badge: {
    borderRadius: 4,
    padding: '0 8px',
    fontWeight: mixins.fontWeight500,
    fontSize: mixins.fontSize12,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 50
  },
  engaged: {
    backgroundColor: mixins.accentColor,
    color: mixins.accentGreen
  },
  behind: {
    backgroundColor: mixins.accentLightRed,
    color: mixins.accentRed
  },
  slipping: {
    backgroundColor: mixins.accentLightOrange,
    color: mixins.accentBrown
  },
  detailwrapper: {
    padding: '0 12px'
  }
}));

export default StudentListStyles;
